import { OperationPlansPerEvCar } from "@/models/operationPlans";
import {
  sticky,
  editablePlan,
  labelOf,
  hover,
  duplicateShifts,
} from "@/pages/OperationPlans/OperationPlansConstansts";
import { uuidv4 } from "@/util";
import { Link, TableCell, TableRow } from "@mui/material";

export type RowsType = {
  plans: OperationPlansPerEvCar[];
  dateLabels: string[];
  clickable: boolean;
  onClickPlan: (planId: number) => void;
};
export const Rows = ({
  plans,
  dateLabels,
  clickable,
  onClickPlan,
}: RowsType) => (
  <>
    {plans.map((evCar) => (
      <TableRow key={evCar.evCarId} sx={{ ...hover }}>
        <TableCell
          className="padding-left-right-none"
          sx={{
            ...sticky,
            left: 0,
            textAlign: "center",
            wordBreak: "break-all",
          }}
        >
          {evCar.officeName}
        </TableCell>
        <TableCell
          sx={{
            ...sticky,
            left: 240,
            textAlign: "center",
            wordBreak: "break-all",
          }}
        >
          {evCar.vehicleCode}
        </TableCell>
        {dateLabels.map((targetDate) => {
          const targetPlan = evCar.carOperationPlansDisplay.find((s) => {
            const d = new Date(s.targetDate);
            return `${d.getMonth() + 1}/${d.getDate()}` === targetDate;
          });
          if (targetPlan == null) {
            return (
              <TableCell
                key={uuidv4()}
                sx={{ backgroundColor: "inherit", minWidth: 140 }}
              ></TableCell>
            );
          }

          return (
            <TableCell
              key={`${targetPlan.id}${targetPlan.createdAt}`}
              sx={{
                minWidth: 140,
                textAlign: "center",
                backgroundColor: duplicateShifts(targetPlan)
                  ? "#f9c1cf"
                  : "inherit",
              }}
            >
              {clickable && editablePlan(targetPlan) ? (
                <Link
                  component="button"
                  onClick={() => onClickPlan(targetPlan.id)}
                >
                  {labelOf(targetPlan)}
                </Link>
              ) : (
                <>{labelOf(targetPlan)}</>
              )}
            </TableCell>
          );
        })}
      </TableRow>
    ))}
  </>
);
